import { CREDIT_CARD } from '../../variables';
import VerifyPayment from './verify-payment';
import WindcavePayment from './windcave-payment';
import { useBookingData } from '../../context/BookingContext';

const CashSaleDialogue = ({ closeCallback }) => {

    const { booking } = useBookingData();

    const creditCardPayment = booking?.paymentType === CREDIT_CARD;

    return (
        <div className="w-80">
            { creditCardPayment ? <WindcavePayment /> : <VerifyPayment closeCallback={closeCallback} />}
        </div>
    )
}

export default CashSaleDialogue;
